import axios from "axios";
import { timeoutSmall, timeoutStandart, urlApi, getApiUrl } from ".";
import { SecureStorage } from "@helpers/storage";

export function ShareWallet(idUser, valueLimit) {
    return new Promise((resolve, reject) => {
        SecureStorage.getItemAsync("TokenUser").then((token) => {
            var config = {
                method: "post",
                url: getApiUrl(`/api/v1/Wallet/ShareWallet`),
                headers: {
                    Authorization: "Bearer " + token,
                },
                params: {
                    "idUser": idUser,
                    "inLimitValue": (valueLimit ?? 0) > 0,
                    "valueLimitValue": valueLimit
                },
                timeout: timeoutStandart
            };
            axios(config)
                .then((response) => {
                    if (response.status == 200) {
                        resolve(response.data);
                    } else {
                        reject(response);
                    }
                })
                .catch((error) => {
                    reject(error.response.data);
                });
        });
    });
}

export function GetShareWalletUsers() {
    return new Promise((resolve, reject) => {
        SecureStorage.getItemAsync("TokenUser").then((token) => {
            var config = {
                method: "get",
                url: getApiUrl(`/api/v1/Wallet/GetSharedWalletUsers`),
                headers: {
                    Authorization: "Bearer " + token,
                },
                timeout: timeoutSmall
            };
            axios(config)
                .then((response) => {
                    if (response.status == 200) {
                        resolve(response.data);
                    } else {
                        reject(response);
                    }
                })
                .catch((error) => {
                    reject(error.response.data);
                });
        });
    });
}

export function RemoveSharedWallet(idWalletShared) {
    return new Promise((resolve, reject) => {
        SecureStorage.getItemAsync("TokenUser").then((token) => {
            var config = {
                method: "delete",
                url: getApiUrl(`/api/v1/Wallet/RemoveSharedWallet`),
                headers: {
                    Authorization: "Bearer " + token,
                },
                params:{
                    "idWalletShared": idWalletShared
                },
                timeout: timeoutStandart
            };
            axios(config)
                .then((response) => {
                    if (response.status == 200) {
                        resolve(response.data);
                    } else {
                        reject(response);
                    }
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    });
}

export function RemoveSharedWalletOwner(idWallet, idWalletShared, idUserShared) {
    return new Promise((resolve, reject) => {
        SecureStorage.getItemAsync("TokenUser").then((token) => {
            var config = {
                method: "delete",
                url: getApiUrl(`/api/v1/Wallet/RemoveSharedWalletOwner`),
                headers: {
                    Authorization: "Bearer " + token,
                },
                params:{
                    "idWallet": idWallet,
                    "idWalletShared": idWalletShared,
                    "idUserShared": idUserShared
                },
                timeout: timeoutStandart
            };
            axios(config)
                .then((response) => {
                    if (response.status == 200) {
                        resolve(response.data);
                    } else {
                        reject(response);
                    }
                })
                .catch((error) => {
                    reject(error.response.data);
                });
        });
    });
}